module.exports = __webpack_public_path__ + "img/iconUser.055a9197.png";